<template>
  <div>
    <a-modal
      v-model="visible"
      :loading="loading"
      title="Homework Details"
      :width="this.settings['isMobileView'] ? 480 : 720"
    >
      <template slot="footer">
        <a-button key="back" type="primary" @click="handleCancel"
          >Close</a-button
        >
      </template>

      <div class="row">
        <div class="col-12 col-md-9">
          <h5 class="font-weight-bolder">{{data.title}}</h5>
          <p v-if="data.school_class && data.section && data.subject">
            Class: {{ data.school_class.name }} | Section: {{ data.section.name }} | Subject: {{ data.subject.name }}
          </p>
          <p>Due Date: {{ data.due_date }}</p>
          <p>{{data.description}}</p>
        </div>

        <div class="col-12 col-md-3">
          <div class="text-right">
<!--            <a-tooltip-->
<!--              placement="top"-->
<!--              title="Edit Homework"-->
<!--            >-->
<!--              <a href="javascript:" class="mr-5" @click="showEditModal(record)">-->
<!--                <i class="fe fe-edit text-primary" />-->
<!--              </a>-->
<!--            </a-tooltip>-->

            <a-tooltip
              placement="top"
              title="Delete Homework"
            >
              <a href="javascript:" @click="handleDelete(data)">
                <i class="fe fe-trash text-danger" />
              </a>
            </a-tooltip>
          </div>
        </div>
      </div>

      <hr />

      <div>
        <div class="row justify-content-between">
          <div class="col-12">
            <h5 class="card-title">
              <span class="text-gray-6">Homework Files</span>
            </h5>
                <ul class="list-group list-group-flush" v-if="data.homeworkfiles">
                  <li
                    class="list-group-item d-flex justify-content-between align-items-center"
                    v-for="homeworkfile in data.homeworkfiles"
                    :key="homeworkfile.id"
                  >
<!--                    <p class="mb-0">{{ homeworkfile.original_file_name }}</p>-->
                    <a :href="homeworkfile.file" target="_blank"><span class="fa fa-download"></span> {{homeworkfile.file.split('/').pop()}}</a>
                  </li>
                </ul>
          </div>
        </div>
      </div>

    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ViewHomework',
  data: function () {
    return {
      visible: false,
      loading: false,
      data: {},
    }
  },
  mounted: function () {
    this.$eventBus.$on('openViewForm', this.openModal)
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  methods: {
    openModal(record) {
      this.visible = true
      this.loading = true
      this.$http.get(`/api/homework/single/${record.id}`)
        .then(data => {
          this.data = data.data.data
        })
        .catch(error => {
          console.error('API Error:', error)
        })
    },
    handleCancel() {
      this.visible = false
    },

    handleDelete(data) {
      this.loading = true
      this.$confirm({
        title: 'Are you sure to delete this record?',
        content: 'Clicking yes will delete this homework.',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/homework/' + data.id)
            .then((resp) => {
              if (resp.status === 200) {
                this.$notification['success']({
                  message: 'Deleted Successfully!',
                  description: 'The homework has been deleted.',
                })
                this.visible = false
                this.$nprogress.done()
                this.$emit('updateTable') // Reload the table
                this.loading = true
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data. Please try again later.',
                })
                this.visible = false
                this.loading = false
                this.$emit('updateTable') // Reload the table
              }
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
              this.visible = false
              this.loading = false
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
